import React, { forwardRef } from "react";
import reactStringReplace from "react-string-replace";

import type {
	PolymorphicComponentPropsWithRef,
	PolymorphicRef,
} from "../../types/polymorphic-component";

export type TextWithAbbreviationsProps<C extends React.ElementType> = Omit<
	PolymorphicComponentPropsWithRef<C, {}>,
	"children"
> & {
	children: string;
};

type TextWithAbbreviationsComponent = <C extends React.ElementType = "div">(
	props: TextWithAbbreviationsProps<C>,
) => React.ReactNode;

export const TextWithAbbreviations: TextWithAbbreviationsComponent = forwardRef(
	<C extends React.ElementType = "div">(
		{ as, children, ...props }: TextWithAbbreviationsProps<C>,
		ref?: PolymorphicRef<C>,
	) => {
		const Component: "div" | C = as ?? "div";
		let text;

		text = reactStringReplace(children, /\[\[\[(.*?)\]\]\]/, (match, i) => (
			<sup key={i}>{match}</sup>
		));
		text = reactStringReplace(text, /\[\[(.*?)\]\]/, (match, i) => (
			<sub key={i}>{match}</sub>
		));

		return (
			<Component {...props} ref={ref}>
				{text}
			</Component>
		);
	},
);
